<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      <div class="header-logo">&nbsp;</div>
    </ion-title>
  </ion-toolbar>
</ion-header>


<ion-content no-bounce class="no-scroll ion-padding">
@if(mode == 'standard') {
  <div [class]="'ring-container' + (isPlayingAnimation ? ' animated' : '' ) + (onboarding ? ' onboarding' : ' passon')" #ringContainer>
  <div class="ring">
    <svg viewBox="0 0 100 100">

      <foreignObject class="logoBack"  x="0" y="0" width="100" height="100">
        <div class="logoGradient" xmlns="http://www.w3.org/1999/xhtml"></div>
      </foreignObject>

      <g class="logoBlend">
          <rect x="0" y="0" width="100" height="100" />
          <path d="M 50 98 a 48 48 0 0 1 0 -96 48 48 0 0 1 0 96" />
          <polygon points="48,98 50,88 52,98" />
      </g>
    </svg>
    <div class="counter">
      <div class="zehner">
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
      </div>
      <div class="einer">
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
        <div>0</div>
        <div>1</div>
        <div>2</div>
        <div>3</div>
        <div>4</div>
        <div>5</div>
        <div>6</div>
        <div>7</div>
        <div>8</div>
        <div>9</div>
      </div>
      <div class="cover">
      </div>
    </div>
    <div class="info" id="info0">
      <div class="main">Hallo {{name}}</div>
      <div class="sub">Let's go!</div>
    </div>
    <div class="info" id="info1">
      <div class="main" translate>MENU.TODAY.NAME</div>
    </div>
    <div class="info" id="info2">
      <div class="main" translate>MENU.COREFACTS.NAME</div>
    </div>
    <div class="info" id="info3">
      <div class="main" translate>MENU.PERSONAL.NAME</div>
    </div>
    <div class="info" id="info4">
      <div class="main" translate>MENU.KNOWHOW.NAME</div>
    </div>
    <div class="info onboarding" id="onboarding1">
      <span class="onboarding-message1" *ngIf="onboarding" [innerHTML]="'LOGIN.ONBOARDING.GREETING' | translate"></span>
    </div>
    <div class="info onboarding" id="onboarding2">
      <span class="onboarding-message1" *ngIf="onboarding" [innerHTML]="'LOGIN.ONBOARDING.STARTING' | translate"></span>
    </div>
  </div>
  <div class="dot-button" id="dot1"></div>
  <div class="dot-button" id="dot2"></div>
  <div class="dot-button" id="dot3"></div>
  <div class="dot-button" id="dot4"></div>
</div>
}
</ion-content>

<ion-footer>
  <div class="v-box align-center" style="padding: 8px 16px">
    <ng-template [ngIf]="!authenticated">
      <ion-spinner color="dark" style="margin: 8px"></ion-spinner>
    </ng-template>
    <!--ng-template [ngIf]="authenticated">
      <ion-button fill="fill" expand="block" color="light" shape="round" style="width: 100%" *ngIf="!onboarding" (click)="onNextClick()"><div translate>COMMON.NEXT</div></ion-button>
      <ion-button fill="fill" expand="block" color="light" shape="round" style="width: 100%" *ngIf="onboarding" (click)="onOnboardingClick()"><div translate>LOGIN.ONBOARDING.START</div></ion-button>
      <ion-button fill="fill" expand="block" color="light" shape="round" style="width: 100%" *ngIf="onboarding" (click)="onSkipClick()"><div translate>LOGIN.ONBOARDING.SKIP</div></ion-button>
    </ng-template-->
  </div>
</ion-footer>
